import {uuid} from 'uuidv4';
import {addAutomationBreakpoint} from 'operations/actions.js';

export const onVolumePatternChange = (track, oldPatternNumber, volume, time) => {
    let {sequencerEngine} = track;
    let state = sequencerEngine.state;
    let parameter = track.volumeParameter;
    if (!track.patterns[oldPatternNumber]) {
        return track.setVolume(
            volume,
            true, // automation = true
            true); // bulk = true
    }

    let oldVolume = track.patterns[oldPatternNumber].volume;
    let update;

    if (state.mix.isRecordingMix) {
        if (!isSliderDown(state, parameter)) {
            // addBreakPoints(sequencerEngine, oldPatternNumber, parameter, oldVolume, volume);
            update = track.setVolume(volume, true, true, time);
        }
    } else if (state.mix.isPlayingMix) {
        if (!isSliderDown(state, parameter) &&
            !parameter.mixAutomation.hasEventsAfterStep(sequencerEngine.trackStep)) {
            update = track.setVolume(volume, true, true, time);
        }
    } else {
        update = track.setVolume(volume, true, true, time);
    }
    return update;
};

export const onParameterPatternChange = (sequencerEngine, parameter, oldPatternNumber, time) => {
    let state = sequencerEngine.state;

    if (parameter.isMapped) {
        let accumulator = parameter.isMapped;
        let value = accumulator.getInitialValueForParameter(parameter);
        if (parameter.patternToValue[oldPatternNumber] !== undefined) {
            parameter.patternToValue[oldPatternNumber] = value;
        } else {
            parameter.unlockedValue = value;
        }
    }

    /**
     * RECORDING MIX:
     * If the user is recording AND the slider is down for this 
     * parameter then we must NOT update the parameter, as 
     * the user's intention is for the slider to dictate the value.
     *
     * If the slider is not down, then add 2 break points at this step 
     * and the next step (w/ current value & locked-value, respectively) 
     * AND update the value to the pattern lock value.
     * That way, when the user plays back the mix, it will simulate the 
     * pattern locked parameter changes via automations.
     *
     * PLAYING MIX:
     * If the user is playing a recorded a mix, and there are more 
     * automations left to play after this step, then again,
     * do NOT update the parameter
     * 
     */
    let update;
    if (parameter.automatable) {
        if (state.mix.isRecordingMix) {
            if (!isSliderDown(state, parameter)) {
                // addBreakPoints(sequencerEngine, oldPatternNumber, parameter);
                update = parameter.updateRedux(true, time);
            }
        } else if (state.mix.isPlayingMix) {
            if (!parameter.mixAutomation.hasEventsAfterStep(sequencerEngine.trackStep)) {
                update = parameter.updateRedux(true, time);
            }
        } else {
            update = parameter.updateRedux(true, time);
        }
    }
    
    if (parameter.isMapped) {
        // has an accumulator that we need to update
        let accumulator = parameter.isMapped;
        accumulator.clearParameter(parameter);
    }

    return update;
};

const isSliderDown = (state, parameter) => {
    return state.automation.parameterSliderDown.includes(parameter);
};

const addBreakPoints = async (sequencerEngine, oldPatternNumber, parameter, oldValue, newValue) => {
    let op = sequencerEngine.operationManager;

    oldValue = oldValue !== undefined ? oldValue :
        parameter.patternToValue[oldPatternNumber] !== undefined ?
        parameter.patternToValue[oldPatternNumber] : parameter.unlockedValue;
    newValue = newValue !== undefined ? newValue : parameter.get(true);

    let step1 = sequencerEngine.trackStep - 1;
    let step2 = step1 + 1;
    await op.dispatch(
        addAutomationBreakpoint(
            parameter.mixAutomation, 
            step1,
            oldValue,
            uuid()
        ));

    await op.dispatch(
        addAutomationBreakpoint(
            parameter.mixAutomation, 
            step2,
            newValue,
            uuid()
        ));
};
